module.exports = __webpack_public_path__ + "img/depmap_svg_V21.0603f48e.svg";